module.exports = __webpack_public_path__ + "../resources/img/bg_storage1_02.2ae8e55f.png";